import { effects } from 'redux-saga'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import { receiveSignups } from 'internal-components/src/redux/modules/signup/actions'
import { receiveOffers } from 'internal-components/src/redux/modules/product/index'

export default function* loadSignups({ invocation }) {
  const result = yield effects.call(callWithHmac, invocation.signupLoadList)

  yield effects.put.resolve(receiveSignups(result.signups))
  yield effects.put.resolve(receiveOffers(result.offers))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/loadSignups.js